<template>
  <div class="course-page">
    <section class="wrapper introduce">
      <h2>light course</h2>
      <p>Short video course, focusing on important concept, theories and knowledge to help people establish correct
        understandings on the physics . It's really helpful for learners who just begin to study the AP@ Physics
        courses. There are several demo courses on the right. Please feel free to take a look.</p>
      <img class="bg-img" src="@/assets/img/comet/home/light-course.svg" />
    </section>
    <section class="wrapper video-free">
      <div
        class="video-item"
        v-for="(item, index) in videoList"
        @click="clickVideo(item)"
        :key="index">
        <div class="bg-box"><img :src="item.banner" alt=""><span class="play-btn-circle"><i class="play-btn-delta"></i></span>
        </div>
        <p>{{ item.desc }}</p>
      </div>
    </section>
    <section class="wrapper course-point-box">
      <ct-row wrap="nowrap">
        <ct-col :span="6" class="first-point-list">
          <div
            v-for="item in courseList"
            :key="item.id"
            class="first-point-list-box">
            <div
              :class="{ 'has-new-badge': item.is_new }"
              @click="changeVisible(item)"
              class="first-point-list-item">
              {{ item.text }}
              <span v-if="item.is_new" class="first-has-new">NEW</span>
              <ct-icon class="item-icon" :class="{'rotate90': currentActive === item.id}" name="jiantouyou"></ct-icon>
            </div>
            <el-collapse-transition>
              <div v-if="item.nodes" v-show="item.ownVisible">
                <div
                  v-for="item in item.nodes"
                  :key="item.id"
                  class="first-point-list-box">
                  <div
                    :class="{ active: activeID === item.id, 'has-new-badge': item.is_new}"
                    @click="clickFirstPt(item.id)"
                    class="first-point-list-item second-item">
                    {{ item.text }}
                    <span v-if="item.is_new" class="first-has-new">NEW</span>
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
        </ct-col>
        <ct-col :span="18" class="first-point-content">
          <transition name="scrollgroup">
            <div v-show="currentSecPointDown">
              <sec-card
                class="scrollgroup-item"
                v-for="item in currentSecPointTrue.nodes"
                :item="item"
                @clickThird="clickThird"
                :key="item.id"></sec-card>
              <div style="text-align: center;" key="empty" v-if="!currentSecPointTrue.nodes">The course is about coming
                soon, stay tuned!
              </div>
            </div>
          </transition>
        </ct-col>
      </ct-row>
    </section>
    <section
      v-show="videoOpen"
      class="course-video-container"
      @click.self="onClickOutside">
      <div class="video-modal-box">
        <ali-player
          v-if="source"
          ref="player"
          :outCourse="true"
          :useEncrypt="false"
          :source="source"
          @loaded-video="loaded"></ali-player>
      </div>
    </section>
    <ct-modal
      title=""
      v-if="noticeModal"
      @closed="closedNotice"
      class="goLogModal">
      <p slot="body">Please log in to get access of all knowledge debris and to check your learning progress. If you
        don't have an account, please sign up with your email.</p>
      <div slot="footer">
        <ct-button @click="goRegist" class="go-quiz-btn" size="small" type="primary">Sign up</ct-button>
        <ct-button @click="goLogin" class="go-quiz-btn" size="small" type="secondary">Log in</ct-button>
        <ct-button @click="closedNotice" class="go-quiz-btn" size="small" type="text_secondary_light">Cancel</ct-button>
      </div>
    </ct-modal>
  </div>
</template>

<script>
import AliPlayer from '@ca/components/player/AliPlayer'
import SecondPointCard from './sub/SecondPointCard'
import { mapGetters, mapActions } from 'vuex'
import { vueAppPassportDomin, vueAppDomin } from '@ca/constants/variables.js'
import storage from '@/utils/storage'
import storageKey from '@ca/constants/storageKey'
import api from '../../api'

const videoList = [
  {
    desc: 'Projectile motion',
    href: 'https://video.eduzhixin.cn/c7e711f89e054b13b2a8b852068a0ed0/9dfeeffbbf8ea36397a098187c7d9cb3-sd.mp4',
    banner: (function () {
      return require('@/assets/img/comet/course/1-Projectile motion@2x.png')
    }())
  },
  {
    desc: 'Angular momentum',
    href: 'https://video.eduzhixin.cn/0c42beb168ca4d8ab7747dbf02ef5e3b/2ef0fccdb37158d6d2ab793205ebd1be-sd.mp4',
    banner: (function () {
      return require('@/assets/img/comet/course/2-Angular momentum@2x.png')
    }())
  },
  {
    desc: 'Walking on a boat ',
    href: 'https://video.eduzhixin.cn/a62a9adcc292427b94969ff0603e3e16/78a38522831bc8218745722ce6e529e5-sd.mp4',
    banner: (function () {
      return require('@/assets/img/comet/course/3-Walking on a boat@2x.png')
    }())
  },
  {
    desc: 'Electric field dut to dipole',
    href: 'https://video.eduzhixin.cn/2d3d644d64c947d4bd17e7d172b58946/b2278b1c79c0ca55851d7fe862b79b46-sd.mp4',
    banner: (function () {
      return require('@/assets/img/comet/course/4-Electric field dut to dipole@2x.png')
    }())
  }
]
export default {
  name: 'Courses',
  components: {
    'ali-player': AliPlayer,
    'sec-card': SecondPointCard
  },
  data () {
    return {
      videoList,
      activeID: -1,
      player: null,
      videoOpen: false,
      noticeModal: false,
      currentSecPointTrue: {},
      source: undefined,
      currentSecPointDown: false,
      courseList: [],
      currentActive: -1
    }
  },
  methods: {
    ...mapActions(['getSkillTree']),
    setVideoWidth (padding) {
      const videobox = this.$refs.videobox
      if (videobox) {
        const el = videobox.$el
        const width = el.clientWidth || el.offsetWidth || el.scrollWidth
        if (width) {
          this.videoWidth = width - padding
          this.videoHeight = this.videoWidth * 9 / 16
        }
      }
    },
    clickFirstPt (id) {
      if (this.activeID === id) return
      this.activeID = id
    },
    onClickOutside () {
      if (this.videoOpen) {
        if (this.player) {
          // this.player.dispose()
          this.player = undefined
          this.source = undefined
        }
        this.videoOpen = false
      }
    },
    loaded (e) {
      this.player = e
    },
    clickVideo (item) {
      this.source = item.href
      this.setVideoWidth(48)
      this.$nextTick(() => {
        this.videoOpen = true
      })
    },
    clickThird (item) {
      if (this.isAuthenticated) {
        storage.set(storageKey.COURSE_LEARNING_RECORD, this.activeID)
        this.$router.push(`/courses/${this.activeID}/${item.parent_id}/${item.id}`)
      } else {
        this.noticeModal = true
      }
    },
    closedNotice () {
      this.noticeModal = false
    },
    goLogin () {
      window.location.href = vueAppPassportDomin + 'Login?return_url=' + vueAppDomin + '/courses'
    },
    goRegist () {
      window.location.href = vueAppPassportDomin + 'Register?return_url=' + vueAppDomin + '/courses'
    },
    calFinishStatus (val, data) {
      const a = JSON.parse(JSON.stringify(data))
      Object.keys(a).forEach((el, index) => {
        let b = 0
        for (let i in a[el]) {
          if (a[el][i].video.progress >= 95) {
            if (a[el][i].question.questions) {
              let c = a[el][i].question.finished === a[el][i].question.questions
              b = c ? (b + 1) : b
              a[el][i].status = c ? 'finished' : 'Learning'
            } else {
              b = b + 1
              a[el][i].status = 'finished'
            }
          } else if (a[el][i].video.progress === 0) {
            a[el][i].status = ''
          } else {
            a[el][i].status = 'Learning'
          }
        }
        a[el] = {
          hasLearn: b,
          items: a[el]
        }
      })
      val.nodes.forEach((el, index) => {
        let tempArr = Object.values(a[el.id].items ? a[el.id].items : [])
        el.hasLearn = a[el.id]['hasLearn']
        if (el.nodes) {
          el.nodes.forEach(ele => {
            ele.status = tempArr.find(n => {
              return n.id === ele.id
            }).status
            ele.video = tempArr.find(n => {
              return n.id === ele.id
            }).video
          })
        }
      })
      return val
    },
    changeVisible (item) {
      if (this.visChangeDown) return
      this.visChangeDown = false
      let id = this.currentActive === item.id ? -1 : item.id
      this.activeID = ''
      this.currentActive = id
      const a = JSON.parse(JSON.stringify(this.skillTree))
      a.forEach(el => {
        el.ownVisible = el.id === id
        if (el.id === id && el.nodes) {
          this.activeID = el.nodes[0].id
        }
      })
      this.courseList = a
      setTimeout(() => {
        this.visChangeDown = false
      }, 200)
    },
    getTreeList (data) {
      let temp = []
      Object.keys(data.data).forEach((key) => {
        temp.push(data.data[key].skill_tree)
      })
      return temp.sort((a, b) => a.priority - b.priority)
    },
    handleActiveId (data) {
      this.activeID = ''
      let isFirst = false
      this.courseList.forEach(el => {
        if (el.nodes && !isFirst) {
          isFirst = true
          el.ownVisible = true
          this.currentActive = el.id
          this.activeID = el.nodes[0].id
        }
      })
    }
  },
  mounted () {
    this.$store.dispatch('getSkillTree').then(res => {
      this.courseList = this.getTreeList(res.data)
      if (this.isAuthenticated) {
        let data = res.data
        if (data.code === 1) {
          this.activeID = storage.get(storageKey.COURSE_LEARNING_RECORD)
          if (!this.activeID) {
            this.handleActiveId(res.data)
          }
        }
      } else {
        this.handleActiveId(res.data)
      }
    })
    const padding = 48
    window.addEventListener('resize', () => {
      this.setVideoWidth(padding)
    })
  },
  computed: {
    ...mapGetters(['skillTree', 'isAuthenticated']),
    currentSecPoint () {
      let temp = {}
      this.skillTree.forEach(el => {
        if (el.nodes) {
          el.nodes.forEach(node => {
            if (node.id === this.activeID) {
              temp = node
            }
          })
        }
      })
      return temp
    }
  },
  watch: {
    videoOpen (newVal, oldVal) {
      const h = document.querySelector('html')
      if (newVal) {
        h.style.overflow = 'hidden'
      } else {
        h.style.overflow = ''
      }
    },
    currentSecPoint (val) {
      this.currentSecPointDown = false
      if (!val || !val.nodes) {
        this.currentSecPointTrue = {}
        this.currentSecPointDown = true
        return
      }
      val = JSON.parse(JSON.stringify(val))
      let arr = []
      val.nodes.forEach(element => {
        arr.push(element.id + '')
      })
      arr = JSON.stringify(arr)
      api.videoGetCoursesInfo({
        params: {
          parents: arr
        }
      }).then(res => {
        let data = res.data
        if (data.code === 1) {
          data = data.data
          val = this.calFinishStatus(val, data)
        }
        this.currentSecPointDown = true
        this.currentSecPointTrue = val
      })
    }
  },
  beforeDestroy () {
    const h = document.querySelector('html')
    h.style.overflow = ''
  }
}
</script>

<style lang="scss" scoped>
.introduce {
  margin-top: 16px;
  background: rgba(26, 61, 94, 1);
  border-radius: 2px;
  display: flex;
  padding: 39px 64px;
  justify-content: space-between;
  align-items: center;
  position: relative;

  h2 {
    margin-right: 56px;
    font-size: 28px;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 28px;
    white-space: nowrap;
  }

  p {
    font-size: 16px;
    color: rgba(255, 255, 255, 1);
    line-height: 22px;
    opacity: .8;
  }

  .bg-img {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 126px;
    opacity: .1;
  }
}

.video-free {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;

  .video-item {
    flex: 1;
    margin-right: 24px;
    border-radius: 2px;
    box-shadow: 0px 3px 14px 0px rgba(79, 117, 162, 0.07);
    transition: all .3s ease-in-out;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }

    .bg-box {
      position: relative;
      overflow: hidden;

      > img {
        position: relative;
        transform: scale(1);
        transform-origin: center middle;
        transition: all .3s ease-in-out;
      }

      .play-btn-circle {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: rgba(26, 61, 94, .6);

        .play-btn-delta {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateY(-50%) translateX(-25%);
          width: 0;
          height: 0;
          border-width: 10px 0 10px 12px;
          border-style: solid;
          border-color: transparent transparent transparent #fff;
        }
      }
    }

    &:hover {
      box-shadow: 0px 6px 24px 0px rgba(35, 62, 114, 0.12);

      img {
        transform: scale(1.1);
      }
    }

    img {
      vertical-align: middle;
      width: 100%;
    }

    p {
      padding: 12px 16px;
      font-size: 16px;
      color: rgba(26, 61, 94, 1);
      line-height: 22px;
    }
  }
}

.course-point-box {
  box-shadow: 0px 2px 12px 0px rgba(79, 117, 162, 0.07);
  border-radius: 2px;
  margin-top: 32px;
  margin-bottom: 80px;

  .first-point-list {
    padding: 8px 0;
    min-height: 60vh;
    border-right: 1px solid #EFF4FA;

    .first-point-list-box {
      //padding-left: 16px;
      color: #768B9E;
      transition: all .1s;

      &:hover {
        color: #1A3D5E;
        box-shadow: 0px 2px 16px 0px rgba(35, 62, 114, 0.07);
      }

      .first-point-list-item {
        margin-left: 16px;
        font-size: 14px;
        padding: 11px 0;
        line-height: 22px;
        border-bottom: 1px solid #EFF4FA;
        position: relative;
        cursor: pointer;
        box-shadow: 0px 0 0 0 rgba(35, 62, 114, 0.07);

        &.has-new-badge {
          padding-right: 52px;
        }

        &::before {
          content: '';
          display: block;
          position: absolute;
          left: -32px;
          width: 4px;
          height: 21px;
          background: linear-gradient(135deg, rgba(48, 186, 199, 1) 0%, rgba(55, 202, 215, 1) 100%);
          border-radius: 1px;
          top: 50%;
          transform: translateY(-50%);
          opacity: 0;
          transition: all .2s ease-in;
        }

        &.active {
          color: #1A3D5E;

          &::before {
            opacity: 1;
          }
        }

        .first-has-new {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 8px;
          font-size: 12px;
          color: rgba(255, 255, 255, 1);
          line-height: 20px;
          padding: 0 6px;
          background: rgba(250, 203, 88, 1);
          border-radius: 10px;
        }

        &.second-item {
          margin-left: 32px;
        }
        .item-icon {
          float: right;
          margin-right: 12px;
          &.rotate90 {
            transform: rotate(90deg);
          }
        }
      }

      //&:last-child .first-point-list-item{
      //  border: none;
      //}
    }

  }

  .first-point-content {
    padding: 32px 22px 0;

    .scrollgroup-leave-to, .scrollgroup-leave, .scrollgroup-leave-active {
      opacity: 0;
    }

    .scrollgroup-enter {
      opacity: 0;
      transform: translateY(100px);
    }

    .scrollgroup-enter-active {
      transition: all .3s ease-in-out;
    }
  }

}

.course-video-container {
  position: fixed;
  z-index: 100000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, .3);

  .video-modal-box {
    padding: 0 20px;
    width: 100%;
    max-width: 1092px;
  }
}

.goLogModal {
  .go-quiz-btn {
    float: right;
    margin-left: 16px;
  }
}

@media screen and (max-height: 800px) {
  .course-video-container {
    .video-modal-box {
      max-width: 60%;
    }
  }
}

@media screen and (max-width: 1366px) {
  .course-video-container {
    .video-modal-box {
      max-width: 60%;
    }
  }
}
</style>
<style lang="scss">
.tree .item .title {
  width: 150px;
  height: 20px;
  line-height: 20px;
  display: block;
  padding: 10px 0;
  color: white;
  font-size: 16px;
  position: relative;
}

.tree li a:hover {
  background-color: #CC3333;
}

.tree .item .title b {
  position: absolute;
  right: 10px;
  transition: all ease 0.6s;
}

.up {
  transform: rotate(0deg);
}

.down {
  transform: rotate(180deg);
}

.tree .p_item a {
  padding: 3px 0 0 10px;
  color: white;
  box-sizing: border-box;
  width: 150px;
  height: 30px;
  display: block;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.6);
}
</style>
